import useMediaQuery from './useMediaQuery'
import * as _ from 'styles/helpers'

/**
 * Single source of truth for "is this a mobile viewport" gating.
 *
 * Resolves to `< 1024px` via `_.MQ.before_nav`, the breakpoint the app already
 * treats as mobile in ~48 files (Layout sidebars, the card components, the page
 * toolbar). Anything deciding what a mobile user may see should call this rather
 * than reaching for `useMediaQuery` directly, so the definition stays in one
 * place.
 *
 * Note this is deliberately NOT the same cut-off as the sidebar's Tailwind `md:`
 * drawer classes (768px). Between 768 and 1023 the drawer is already expanded
 * while gating still applies. Reconciling the two is a separate change.
 */
const useIsMobile = (): boolean => useMediaQuery(_.MQ.before_nav)

export default useIsMobile
